<template>
  <div>
    <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
      <v-card color="black" dark>
        <v-card-text>
          <span style="font-size: small;">{{ message }}</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    dialogLoader: Boolean,
    message: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
